import {
  FETCH_MARKETING_PREFERENCES_BEGIN,
  FETCH_MARKETING_PREFERENCES_SUCCESS,
  FETCH_MARKETING_PREFERENCES_FAILURE,
  SET_MARKETING_PREFERENCES_BEGIN,
  SET_MARKETING_PREFERENCES_SUCCESS,
  SET_MARKETING_PREFERENCES_FAILURE,
  HANDLE_MARKETING_PREFERENCES_CHANGE,
  GENERIC_ERROR_MESSAGE
} from "./types";
import { ENDPOINTS } from "utils/endpoints";
import API from "../../../../../Services/API";

export const fetchMarketingPreferences = () => async dispatch => {
  dispatch({ type: FETCH_MARKETING_PREFERENCES_BEGIN });

  try {
    const response = await API({
      method: "post",
      url: ENDPOINTS.FETCH_MARKETING_PREFERENCES
    });

    if (response && response.status === "OK") {
      if (response.data && response.data.optOutInfos) {
        dispatch({
          type: FETCH_MARKETING_PREFERENCES_SUCCESS,
          payload: response.data.optOutInfos
        });
      }
    } else {
      dispatch({
        type: FETCH_MARKETING_PREFERENCES_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_MARKETING_PREFERENCES_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};

export const handleMarketingPreferencesChange = checkbox => (dispatch, getState) => {
  const payload = [
    ...getState().marketingPreferences.map(el => {
      if (checkbox.type === el.type) {
        return {
          ...el,
          dataList: el.dataList.map(item => {
            if (item.contactMethod === checkbox.contactMethod) {
              return {
                ...item,
                value: item.value === "Y" ? "N" : "Y"
              };
            }
            return item;
          })
        };
      }
      return el;
    })
  ];

  dispatch({
    type: HANDLE_MARKETING_PREFERENCES_CHANGE,
    payload
  });
};

export const setMarketingPreferences = () => async (dispatch, getState) => {
  dispatch({
    type: SET_MARKETING_PREFERENCES_BEGIN
  });

  try {
    const response = await API({
      method: "post",
      url: ENDPOINTS.SET_MARKETING_PREFERENCES,
      data: {
        optOutInfos: getState().marketingPreferences
      }
    });

    if (response && response.status === "OK") {
      dispatch({ type: SET_MARKETING_PREFERENCES_SUCCESS });
    } else {
      dispatch({ type: SET_MARKETING_PREFERENCES_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    dispatch({
      type: SET_MARKETING_PREFERENCES_FAILURE,
      payload: error.response.description || GENERIC_ERROR_MESSAGE
    });
  }
};
